module.exports = __webpack_public_path__ + "res/img/icon-switch.872f1458.png";